import { useQuery } from '@tanstack/react-query';

import type { QueryFunction } from '@frontend/api';
import { getLineItemSettingsKey, useRequest } from '@frontend/api';

import type { LineItemSettingsData, LineItemSettingsKey } from './types';

export const useGetLineItemSettings: QueryFunction<
  LineItemSettingsData,
  [],
  LineItemSettingsKey
> = ({ requestOptions, queryOptions } = {}) => {
  const queryKey = getLineItemSettingsKey();
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/quote_item_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
